import React from 'react';
import ByzzerToggle from '@/components/form/ByzzerToggle';
import classnames from 'classnames';
import { ByzzerButton } from '@byzzer/ui-components';
import { CharacteristicCriteriaBuilder } from '@/components/CharacteristicCriteriaBuilder';

const baseClassName = 'segment-selector';
const andOption = {
    display: 'And',
    value: 'and',
};
const orOption = {
    display: 'Or',
    value: 'or',
};

export function SegmentSelector({
    index,
    removable,
    includeToggle,
    char,
    onRemoveSelector,
    onRowChange,
    onToggleChange,
    selectedCategories,
    variant = 'default',
}) {
    return (
        <>
            {includeToggle && (
                <ByzzerToggle
                    className={`${baseClassName}__and-or`}
                    leftOption={andOption}
                    rightOption={orOption}
                    value={char.and}
                    onChange={onToggleChange}
                />
            )}
            <div
                className={classnames(baseClassName, {
                    [`${baseClassName}--removable`]: removable,
                })}
            >
                <CharacteristicCriteriaBuilder
                    className={`${baseClassName}__criteria-builder`}
                    categories={selectedCategories}
                    includeUpcOption={true}
                    showAddConditionButton={false}
                    showRemoveConditionButton={false}
                    value={[
                        {
                            characteristic: char.characteristic,
                            characteristicDisplayValue: char.characteristicDisplayValue,
                            condition: char.condition,
                            value: char.value,
                            isCustom: char.isCustom,
                        },
                    ]}
                    selectAllListedValuesEnabled={true}
                    onChange={(e) => onRowChange(index, e.value?.[0], e)}
                />
                <ByzzerButton onClick={() => onRemoveSelector(index, char)}>x</ByzzerButton>
            </div>
        </>
    );
}

